import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import { IconButton, Tooltip } from "@mui/material";
import { FaEdit } from "react-icons/fa";
import AdjuntoAutoevaluacion from "../AdjuntoAutoevaluacion";
import Cookies from "universal-cookie";

function EditarPerfil(props) {
  const cookie = new Cookies();
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  const [postDescripcion, setPostDescripcion] = useState([]);

  const postData = (e) => {
    e.preventDefault(e);
    if (postDescripcion != "") {
      axios({
        method: "put",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url:
          "https://suadesarrollo.azurewebsites.net/api/ActualizaPerfilAutoevaluacion/" +
          props.Id,
        data: {
          descripcion: postDescripcion,
        },
      })
        .then((Response) => {
          console.log(Response.data);
          alert("Actualizado con exito!");
          window.location.reload("/");
        })
        .catch((error) => {
          console.log(error);
          alert("Error al Actualizar" + error);
        });
    }
  };
  return (
    <div className="test">
      <Tooltip title="Editar">
        <IconButton color="warning" onClick={handleOpenModalTest}>
          <FaEdit />
        </IconButton>
      </Tooltip>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
        style={{
          overlay: { zIndex: 2000 },
        }}
      >
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    Editar Información
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <form className="user">
                      <div className="form-group row">
                        <div className="col-sm-12">
                          <textarea
                            rows={6}
                            type="text"
                            className="form-control "
                            onChange={(e) => setPostDescripcion(e.target.value)}
                          >
                            {props.descripcion}
                          </textarea>
                        </div>
                      </div>

                      <hr />
                      <a>
                        <button
                          className="btn btn-primary btn-user btn-block"
                          onClick={postData}
                        >
                          Guardar
                        </button>
                      </a>
                      <hr />

                      <div className="text-center">
                        <AdjuntoAutoevaluacion
                          idSolicitud={cookie.get("institucionid")}
                          idSubtitulo={props.subtitulosId}
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}
export default EditarPerfil;
